<header class="flex header">
  <h2>{{ 'CurrentShift.edit_shift' | translateWF: 'Edit Current Shift' }}</h2>
  <button type="button" class="close-button" (click)="onClose()">
    <i class="pi pi-times"></i>
  </button>
</header>

<div class="content">
  <div class="form-box">
    <label for="shift">{{ 'CurrentShift.shift' | translateWF: 'Shift' }} *</label>
    <p-select
      id="shift"
      [formControl]="shiftControl"
      [options]="shiftOptions"
      optionLabel="label"
      optionValue="value"
      placeholder="{{ 'CurrentShift.select_shift' | translateWF: 'Select a shift' }}"
      class="w-full"
      [ngClass]="{ 'ng-invalid ng-dirty': shiftControl.invalid && shiftControl.dirty }"
    />
    <small class="p-error" *ngIf="shiftControl.invalid && shiftControl.dirty">
      {{ 'CurrentShift.shift_required' | translateWF: 'Shift is required' }}
    </small>
  </div>
</div>

<footer>
  <p-button [label]="'CurrentShift.cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onClose()" />
  <p-button [label]="'CurrentShift.save' | translateWF: 'Save'" (click)="onSave()" />
</footer>
